(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_download-files-accordion-row"] && !Shopify.designMode) return;
  try {
    (function () {
    /**
     * Format a byte count as a compact string with the unit joined
     * directly — no space between number and unit.
     * e.g.  512  → "512B"
     *       1536 → "1.5KB"
     *       1048576 → "1MB"
     *       1572864 → "1.5MB"
     *
     * Rules:
     *  - < 1024             → whole number + "B"
     *  - < 1024^2           → up to 1 decimal + "KB" (drop trailing ".0")
     *  - < 1024^3           → up to 1 decimal + "MB" (drop trailing ".0")
     *  - otherwise          → up to 1 decimal + "GB" (drop trailing ".0")
     */
    function formatBytes(bytes) {
      var KB = 1024;
      var MB = KB * 1024;
      var GB = MB * 1024;

      if (bytes < KB) {
        return bytes + 'B';
      }

      var value, unit;
      if (bytes < MB) {
        value = bytes / KB;
        unit  = 'KB';
      } else if (bytes < GB) {
        value = bytes / MB;
        unit  = 'MB';
      } else {
        value = bytes / GB;
        unit  = 'GB';
      }

      // Round to at most 1 decimal place, then strip a trailing ".0"
      var rounded = parseFloat(value.toFixed(1)).toString();
      return rounded + unit;
    }

    /**
     * Accordion toggle — wired once per block on DOMContentLoaded.
     * A block's unique class prevents clashes when multiple instances
     * are on the same page.
     */
    function initBlock(blockEl) {

      // ── Async file-size fetches ────────────────────────────────────────
      // Each HEAD request is fire-and-forget. We wrap in try/catch so that
      // CORS blocks (Shopify's file CDN may refuse cross-origin HEAD
      // requests) are silently swallowed — the size span is simply left
      // empty and the meta line shows only the file type. This is expected
      // behaviour and must not cause noisy console errors.
      var sizeSpans = blockEl.querySelectorAll('.download-list__size[data-file-url]');
      sizeSpans.forEach(function (span) {
        var url = span.getAttribute('data-file-url');
        if (!url) return;

        // Remove the loading flag immediately; span stays empty until/unless
        // the fetch succeeds.
        span.removeAttribute('data-loading');

        // Silence any network / CORS errors — a single quiet catch is enough.
        try {
          fetch(url, { method: 'HEAD' })
            .then(function (response) {
              try {
                var cl = response.headers.get('Content-Length');
                if (cl !== null && cl !== '') {
                  var bytes = parseInt(cl, 10);
                  if (!isNaN(bytes) && bytes >= 0) {
                    // Inject ", 123KB" — comma+space prefix, then TYPE-joined unit.
                    span.textContent = ', ' + formatBytes(bytes);
                  }
                }
                // If Content-Length is absent, leave span empty (type-only fallback).
              } catch (_inner) {
                // Header parsing failed; leave span empty.
              }
            })
            .catch(function () {
              // Network error or CORS block — silently omit the size.
              // This is expected when Shopify's CDN rejects the HEAD request.
            });
        } catch (_outer) {
          // fetch() itself threw (e.g. invalid URL) — silently omit.
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      // Support multiple block instances on the same page.
      var blocks = document.querySelectorAll('.download-list');
      blocks.forEach(initBlock);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
